export default __webpack_public_path__ + "static/media/inox.0b0ecfb2.svg";